export enum PageTitle {
	CoverPage = 'Cover Page',
    FirstPage = 'First Page',
	SecondPage = 'Second Page',
    ThirdPage = 'Third Page',
    FourthPage = 'Fourth Page',
    FifthPage = 'Fifth Page',
    SixthPage = 'Sixth Page'
}

export enum PdfDocumentType {
	CoverPageComponent = 'CoverPageComponent',
	FirstPageComponent = 'FirstPageComponent',
    SecondPageComponent = 'SecondPageComponent',
    ThirdPageComponent = 'ThirdPageComponent',
    FourthPageComponent = 'FourthPageComponent',
    FifthPageComponent = 'FifthPageComponent',
    SixthPageComponent = 'SixthPageComponent',
}
